import { render, staticRenderFns } from "./BadgeGroup.vue?vue&type=template&id=050bc376"
import script from "./BadgeGroup.vue?vue&type=script&lang=ts"
export * from "./BadgeGroup.vue?vue&type=script&lang=ts"
import style0 from "./BadgeGroup.vue?vue&type=style&index=0&id=050bc376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports